import {
  Heading,
  Box,
  Wrap,
  WrapItem,
  Stat,
  StatLabel,
  StatNumber,
  HStack,
  VStack,
  Text,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import BackButton from "../../components/BackButton";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import QueryStateWrapper from "../../components/QueryStateWrapper";
import { MapContext } from "../../context/map.context";
import { useRoute } from "../../data/mazemap.api";

function Directions() {
  const { from, to } = useParams<{ from: string; to: string }>();
  const { watchLocation, personalLocation } = useContext(MapContext);

  useEffect(() => {
    watchLocation();
  }, [watchLocation]);

  const fromData = useMemo(() => {
    if (!from) return;
    const [lng, lat] = from?.split(",").map(parseFloat);

    return {
      lngLat: { lng, lat },
      zLevel: 1,
    };
  }, [from]);

  const toData = useMemo(() => {
    if (!to) return;
    const [lng, lat] = to?.split(",").map(parseFloat);

    return {
      lngLat: { lng, lat },
      zLevel: 1,
    };
  }, [to]);

  const findCurrentInstruction = (coordinates: number[][]) => {
    const latLimit: number = 0.0000448// 5 meters
    const longLimit: number = 0.0000633 // 5 meters
    for (let pos of coordinates ){
      if (personalLocation?.coords && personalLocation?.coords.latitude < pos[1] + latLimit && personalLocation?.coords.latitude > pos[1] - latLimit && personalLocation?.coords.longitude < pos[0] + longLimit && personalLocation?.coords.longitude > pos[0] - longLimit){
        return true
      }
    }
    return false
  }

  const { data, isLoading, isError, instructionsData, isInstructionsError, isInstructionsLoading } = useRoute(fromData, toData);

  console.log(instructionsData, personalLocation);

  return (
    <HybridBottomSheetDrawer>
      <BackButton />

      <Box p={8}>
        <Heading size="md" mb={4}>
          Directions
        </Heading>
        <QueryStateWrapper isLoading={isLoading} data={data} error={isError}>
          <HStack spacing={4}>
            <Stat>
              <StatLabel>Distance</StatLabel>
              <StatNumber>
                {/* @ts-ignore */}
                {(data?.properties?.pathMetrics?.distanceWalkingMeters ?? 0) /
                  1000}{" "}
                km
              </StatNumber>
            </Stat>
            <Stat>
              <StatLabel>Duration (Walking)</StatLabel>
              <StatNumber>
                {/* @ts-ignore */}
                {data?.properties?.pathMetrics?.durationWalkingMinutes ??
                  0}{" "}
                minutes
              </StatNumber>
            </Stat>
          </HStack>
        </QueryStateWrapper>
        <Heading size="md" my={4}>Instructions</Heading>
        {!instructionsData && !isInstructionsLoading && <Text>This feature is not available outside of campus. You must be within campus to access the instructions.</Text>}
        <QueryStateWrapper isLoading={isInstructionsLoading} data={instructionsData} error={isInstructionsError}>
          <VStack align={"start"}>
            {instructionsData?.routes?.[0]?.legs[0]?.steps.map((step: any, i: number) => {
              return (
                <Box>
                  <Text>{i+1}. {step.instruction}</Text>
                </Box>
              )
            })}
          </VStack>
        </QueryStateWrapper>
      </Box>
    </HybridBottomSheetDrawer>
  );
}

export default Directions;
